<ng-container [ngSwitch]="item.type" *ngFor="let item of items || []">
  <ng-container *ngSwitchCase="'text'">
    <result-rich-text-text [model]="item" [highlights]="highlights"></result-rich-text-text>
  </ng-container>
  <ng-container *ngSwitchCase="'person'">
    <result-rich-text-person (invoke)="invoke.emit($event)" [model]="item" [highlights]="highlights"></result-rich-text-person>
  </ng-container>
  <ng-container *ngSwitchCase="'rich_text_emoji'">
    <result-rich-text-emoji [model]="item"></result-rich-text-emoji>
  </ng-container>
  <ng-container *ngSwitchCase="'link'">
    <result-rich-text-link (invoke)="invoke.emit($event)" [model]="item" [highlights]="highlights"></result-rich-text-link>
  </ng-container>
</ng-container>
